/**
 * @generated SignedSource<<95b98d5e6f3de584ea4029f0d9f65fcb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomeTabsNavigator_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly club: {
        readonly departments: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly anyFacilityEventsEnabled: boolean;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"HomeScreen_session" | "TabBarNav_session">;
  readonly " $fragmentType": "HomeTabsNavigator_session";
};
export type HomeTabsNavigator_session$key = {
  readonly " $data"?: HomeTabsNavigator_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"HomeTabsNavigator_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomeTabsNavigator_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TabBarNav_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HomeScreen_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DepartmentConnection",
                  "kind": "LinkedField",
                  "name": "departments",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DepartmentEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Department",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "anyFacilityEventsEnabled",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "dcddb8862694a4f55ed8eec58cdfb37d";

export default node;
